import { makeStyles } from '@material-ui/core';

type StylesProps = {
  linesToShow: number;
};

export default makeStyles(theme => ({
  root: {
    display: '-webkit-box',
    '-webkit-line-clamp': (props: StylesProps) => props.linesToShow,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
  },
  tooltip: {
    backgroundColor: theme.palette.common.white,
    boxShadow: theme.shadows[3],
    color: theme.palette.text.primary,
    maxWidth: '680px',
  },
}));
